import videojs from 'video.js';
import './ChatIcon.scss';
import { notifyWithFullscreenClose } from '../../utiliti';

const ClickableComponent = videojs.getComponent('ClickableComponent');

class ChatIcon extends ClickableComponent {
  createEl() {
    const el = super.createEl('button', {
      className: 'vjs-control vjs-button vjs-chat-icon-section',
      id: 'display-chat-button'
    });

    this.contentEl_ = videojs.dom.createEl('img', {
      src: 'comments.svg',
      id: 'chat',
      className:
        'vjs-custom-action-icons vjs-custom-action-icons-animate vjs-inactive'
    });
    el.appendChild(this.contentEl_);

    return el;
  }

  handleClick(evt) {
    notifyWithFullscreenClose(this.player_, { type: 'CHAT_CLICKED' });
  }
}

ChatIcon.prototype.controlText_ = 'Live Chat';

videojs.registerComponent('Chat', ChatIcon);
